/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserProfileDetailsDto interface.
 */
export function instanceOfUserProfileDetailsDto(value) {
    let isInstance = true;
    return isInstance;
}
export function UserProfileDetailsDtoFromJSON(json) {
    return UserProfileDetailsDtoFromJSONTyped(json, false);
}
export function UserProfileDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'givenName': !exists(json, 'givenName') ? undefined : json['givenName'],
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
        'picture': !exists(json, 'picture') ? undefined : json['picture'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
    };
}
export function UserProfileDetailsDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'countryCode': value.countryCode,
        'name': value.name,
        'givenName': value.givenName,
        'familyName': value.familyName,
        'nickname': value.nickname,
        'picture': value.picture,
        'phoneNumber': value.phoneNumber,
    };
}
